import type { ApiClient } from "@kundeninfo/api-client";

/** Die Ausschnitte des Klienten für die Fremdtickets (Nachtrag 1f) — in Tests `vi.fn`-Objekte. */
export type FremdkontenClient = Pick<ApiClient,
  "listFremdkonten" | "listFremdkontoKandidaten" | "setFremdkonto" | "removeFremdkonto" | "syncFremdtickets">;
export type FremdticketsClient = Pick<ApiClient,
  "listFremdtickets" | "getFremdticket" | "setFremdFaelligkeit" | "syncFremdtickets">;

/** Hat der Klient die Fremdkonten-Wege? (Verwaltung › Benutzer reicht einen schmaleren Klienten durch.) */
export function hatFremdkonten(c: object): c is FremdkontenClient {
  const k = c as Partial<FremdkontenClient>;
  return typeof k.listFremdkonten === "function" && typeof k.listFremdkontoKandidaten === "function"
    && typeof k.setFremdkonto === "function" && typeof k.removeFremdkonto === "function"
    && typeof k.syncFremdtickets === "function";
}

/** Label-Filter (Nachtrag 1g, nur ADMIN) — in Tests `vi.fn`-Objekte. */
export type LabelFilterClient = Pick<ApiClient, "getLabelFilter" | "setLabelFilter" | "listLabelKandidaten">;

/** Hat der Klient die Wege des Label-Filters? (Die Schnittstellen-Ansicht bekommt in Tests einen schmaleren.) */
export function hatLabelFilter(c: object): c is LabelFilterClient {
  const k = c as Partial<LabelFilterClient>;
  return typeof k.getLabelFilter === "function" && typeof k.setLabelFilter === "function"
    && typeof k.listLabelKandidaten === "function";
}
